import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router';
import { useSelector } from 'store';

const ContentTitle = () => {
  const { eventTitle } = useSelector((state) => state.currentEvent.mainData) || '';
  const { nameFirst, nameSecond } = useSelector((state) => state.currentContact.mainData) || {};
  const dataLoading = useSelector((state) => state.menu.dataLoading);

  let title = '';
  const location = useLocation();
  if (dataLoading) {
    title = '';
  } else if (location.pathname === '/contact') {
    title = `${nameFirst} ${nameSecond}`;
  } else if (location.pathname.startsWith('/event')) {
    title = eventTitle;
  } else {
    title = '';
  }

  return (
    <Box sx={{ flexGrow: 1, ml: 2 }}>
      <Typography variant="h5">{title}</Typography>
    </Box>
  );
};

export default ContentTitle;
